import { PhX } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

// Rendered above the grid and inside the expanded overlay, which covers the grid.

export interface DrilldownChip {
  key: string;
  label: string;
  text: string;
}

interface DrilldownChipsSignature {
  Args: {
    /** One chip per active drilldown; `key` identifies the drilldown to dismiss. Nothing renders when empty. */
    chips: DrilldownChip[];
    /** Fires with the chip's key when its ✕ is clicked. */
    onDismiss: (key: string) => void;
    /** Fires when "Clear all" is clicked. */
    onClear: () => void;
  };
  Element: HTMLDivElement;
}

const DrilldownChips: TOC<DrilldownChipsSignature> = <template>
  {{#if @chips.length}}
    <div class="tio-wrap-tight" data-test-dashboard-drilldowns ...attributes>
      {{#each @chips as |chip|}}
        <span
          class="tio-inline-row-extra-tight tio-bg-brand-soft tio-fg-brand rounded-full px-3 py-1 tio-type-body-secondary"
          data-test-drilldown-chip
        >
          <span class="tio-type-weight-medium">{{chip.label}}</span>
          <span>{{chip.text}}</span>
          <button
            type="button"
            class="p-1 rounded-full hover:tio-bg-brand-soft-hover"
            title="Clear drilldown"
            aria-label="Clear drilldown on {{chip.label}}"
            {{on "click" (fn @onDismiss chip.key)}}
          >
            <PhX @size={{12}} />
          </button>
        </span>
      {{/each}}
      <button
        type="button"
        class="tio-inline-row-extra-tight rounded-full px-2 py-1 tio-type-body-secondary tio-fg-muted hover:tio-fg-secondary"
        data-test-drilldown-clear
        {{on "click" @onClear}}
      >Clear all</button>
    </div>
  {{/if}}
</template>;

export default DrilldownChips;
